module["exports"] = [
  "visa",
  "mastercard",
  "americanexpress",
  "discover"
];
